// Ports used on purchase orders and shipments.
export const PORTS_OF_LOADING = ['MUNDRA', 'SANTOS', 'SHANGHAI', 'CHENNAI', 'IZMIR', 'ALIAGA', 'HAIPHONG'];
export const PORTS_OF_DISCHARGE = ['FELIXSTOWE', 'SOUTHAMPTON'];
